var exports = {
  "kL": "xf61da738--3f99a8--container",
  "JE": "xf61da738--3f99a8--under-construction",
  "Kk": "xf61da738--3f99a8--icon",
  "UU": "xf61da738--3f99a8--name",
};

module.exports = exports;
